import React, {useEffect, useState} from "react";
import TablaGestion from "../../components/shared/layout/Table";
import {RegistroClinico} from "../../structure/Tables";
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import LocalPrintshopTwoToneIcon from '@mui/icons-material/LocalPrintshopTwoTone';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import {Button, IconButton, MenuItem} from "@mui/material";
import Box from "@mui/material/Box";
import Loader2 from "../../components/shared/layout/Loader2";
import Modal from "@mui/material/Modal";
import {ModalsubCreator} from "../../components/shared/layout/ModalsubSelector";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import {DatePickerCustomed} from "../../components/shared/Litles/dates";
import {PersonaButtonforForms} from "../../components/shared/Litles/PersonaButton";
import {ModalFeatureJsonGestor} from "../../components/shared/Litles/featureModal";
import {ButtonFileUpperForms} from "../../components/FIleUpper/Button/FIleUpperButton";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 250,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};


export default function RegistroClinicoView(props){
    const {data, persona_id, addRow, handleEditar, guardarRegistro, setCatchResponse, setDataResponse, actionPrint, rules, opciones, listCiudades, listEstados, listPaises}=props;
    const [loader, setLoader2]=useState(false)
    const [page, setPage]=useState(0);
    const [json, setJson]=useState({});
    const [opensub, setOpensub]=useState(false)
    const [gestorMedicinaModal,setGestorMedicinaModal]=useState(false)
    const [gestorAlergiasModal,setGestorAlergiasModal]=useState(false)
    const [gestorAntecedentesModal,setGestorAntecedentesModal]=useState(false)
    const [sortModel, setSortModel] = useState([
        {
          field: 'fecha',
          sort: 'asc',
        },
    ]);

    let jsonSetter;

    const addRowCore = () => {
        setOpensub(true)
    }

    const getConfig = (key) => {
        const config = rules;
        let reqConfig = {};

        const expKeys=config.find((element)=>element.nombre==="json_controller")?.configuracion
        if(expKeys){
            const newConf = expKeys[key]
            if(newConf){
                reqConfig = config.find((element) => element.nombre === newConf).configuracion;
            }
        }
        return reqConfig;
    }

    const handleClosesub = async (row)=>{
        if (row) {
            await addRow(row)
        }
        setOpensub(false);
    }

    const openGestorMedicina = (datos) =>{
        const jsonData = datos['medicamento'];
        if(jsonData){
            let dataM = JSON.parse(jsonData);

            setJson(dataM);
        }
        else {
            setJson({});
        }

        setGestorMedicinaModal(true);
    }
    const closeGestorMedicina = () =>{
        setGestorMedicinaModal(false);
    }

    const openGestorAlergias = (datos) =>{
        const jsonData = datos['alergias'];
        if(jsonData){
            let dataM = JSON.parse(jsonData);

            setJson(dataM);
        }
        else {
            setJson({});
        }

        setGestorAlergiasModal(true);
    }
    const closeGestorAlergias = () =>{
        setGestorAlergiasModal(false);
    }

    const openGestorAntecedentes = (datos) =>{
        const jsonData = datos['antecedentes'];
        if(jsonData){
            let dataM = JSON.parse(jsonData);

            setJson(dataM);
        }
        else {
            setJson({});
        }

        setGestorAntecedentesModal(true);
    }
    const closeGestorAntecedentes = () =>{
        setGestorAntecedentesModal(false);
    }

    useEffect(() => {
        setJson({});
    }, [])

    const printButton= actionPrint?<Button
            key={"printRC"}
            id={"boton1"}
            onClick={actionPrint}
            sx={{
                "&:hover":{
                    //background:"#d0d0d0",
                    //borderBottom: "1px solid #d0d0d0"
                },
                width:5,
                padding:0,
            }}
        >
        <LocalPrintshopTwoToneIcon titleAccess="Imprimir Reporte"></LocalPrintshopTwoToneIcon>
    </Button>:null

    const botonesAccion = [
        {
        field: "action",
        headerName: <div  style={{marginBottom:"-10px"}}><AddTwoToneIcon titleAccess="Agregar" onClick={(e)=>addRowCore()}/></div>,
        width: 50,
        sortable: false,
        
        renderCell: (params) => {
            return (
            <div className="cellAction" style={{ display:"flex"}}>
                <div className="viewButton" style={{color:"#d7a200", border:"none"}} onClick={(e)=>{
                if(!params.row.edit){guardarRegistro(params.row)}; params.row.edit= !params.row.edit;
                }} >{params.row.edit?<EditTwoToneIcon titleAccess="Editar" />: <SaveTwoToneIcon titleAccess="Guardar" /> }
                </div>
            </div>
            );
        },
        },
    ];

    const fieldProps = (datos, changeHandler) => {
        jsonSetter = changeHandler;

        return [
            (<Grid item xs={12} md={6} lg={6}>
                <DatePickerCustomed
                    name={"fecha"}
                    value={datos["fecha"] || ''}
                    label={"Fecha"}
                    onChange={(e) => changeHandler({target: {name: "fecha", value: e["$d"]}})}
                >
                </DatePickerCustomed>
            </Grid>),
            (<Grid item xs={12} md={6} lg={6}>
                <TextField
                    fullWidth
                    select
                    name={"ct_establecimiento_id"}
                    value={datos['ct_establecimiento_id'] || 0}
                    label={"Establecimiento"}
                    onChange={(e) => changeHandler(e)}
                >
                    {opciones.detallecatalogo.filter(x => x.catalogo_id === 19).map((x, i) => (
                        <MenuItem key={i} value={x.id}>
                            {x.descripcion}
                        </MenuItem>
                    ))

                    }
                </TextField>
            </Grid>),
            (<Grid item xs={12} md={6} lg={6} display={"flex"}>
                <PersonaButtonforForms setDataResponse={setDataResponse} setCatchResponse={setCatchResponse}
                                       value={datos['doctor_id']} value_name={'doctor_id'}
                                       Label={datos['doctor']} title={'Doctor'} label_name={'doctor'}
                                       handleChange={(id, name, nombrecompleto, label_name) => {
                                           const e = [
                                               {
                                                   name: name,
                                                   value: id,
                                               },
                                               {
                                                   name: label_name,
                                                   value: nombrecompleto,
                                               }
                                           ];
                                           changeHandler(e);
                                       }}/>
            </Grid>),
            (<Grid item xs={12} md={6} lg={6}>
                <TextField
                    fullWidth
                    name={"numero"}
                    value={datos['numero'] || ''}
                    label={"Numero"}
                    onChange={(e) => changeHandler(e)}
                >
                </TextField>
            </Grid>),
            (<Grid item xs={12} md={6} lg={6}>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    maxRows={4}
                    name={"evolucion"}
                    value={datos['evolucion'] || ''}
                    label={"Evolución"}
                    onChange={(e) => changeHandler(e)}
                >
                </TextField>
            </Grid>),
            (<Grid item xs={12} md={6} lg={6}>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    maxRows={4}
                    name={"prescripcion"}
                    value={datos['prescripcion'] || ''}
                    label={"Prescripción"}
                    onChange={(e) => changeHandler(e)}
                >
                </TextField>
            </Grid>),
            (<Grid item xs={12} md={6} lg={6}>
                <Box sx={{display: 'flex', alignItems: 'flex-end'}}>
                    <IconButton onClick={() => openGestorMedicina(datos, changeHandler)}>
                        <EditTwoToneIcon fontSize="inherit"/>
                    </IconButton>
                    <TextField
                        fullWidth
                        InputProps={{
                            readOnly: true
                        }}
                        variant='standard'
                        name={"medicamento"}
                        value={'Medicamento'}
                        label={"Medicamento"}
                    >
                    </TextField>
                </Box>
            </Grid>),
            (<Grid item xs={12} md={6} lg={6}>
                <ButtonFileUpperForms
                    handleChangeReserv={changeHandler}
                    idrefDoc={datos['comprobante_id']}
                    nombredocumento={datos['comprobante_name']}
                    name={'comprobante_id'}
                    persona_id={persona_id}
                    tipoDocumento={64}
                    title={'Comprobante o Ficha Médica.'}/>
            </Grid>),
            (<Grid item xs={12} md={6} lg={6}>
                <Box sx={{display: 'flex', alignItems: 'flex-end'}}>
                    <IconButton onClick={() => openGestorAlergias(datos, changeHandler)}>
                        <EditTwoToneIcon fontSize="inherit"/>
                    </IconButton>
                    <TextField
                        fullWidth
                        InputProps={{
                            readOnly: true
                        }}
                        variant='standard'
                        name={"alergias"}
                        value={'Alergias'}
                        label={"Alergias"}
                    >
                    </TextField>
                </Box>
            </Grid>),,
            (<Grid item xs={12} md={6} lg={6}>
                <Box sx={{display: 'flex', alignItems: 'flex-end'}}>
                    <IconButton onClick={() => openGestorAntecedentes(datos, changeHandler)}>
                        <EditTwoToneIcon fontSize="inherit"/>
                    </IconButton>
                    <TextField
                        fullWidth
                        InputProps={{
                            readOnly: true
                        }}
                        variant='standard'
                        name={"antecedentes"}
                        value={'Antecedentes'}
                        label={"Antecedentes"}
                    >
                    </TextField>
                </Box>
            </Grid>),
        ]
    }
    return(
        <React.Fragment>
            <Modal
                hideBackdrop
                open={opensub}
                onClose={handleClosesub}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={{ ...style, width: 580 }}>
                    <Loader2 onLoader={loader}/>
                    <h2 id="parent-modal-title">Nuevo</h2>
                    <ModalsubCreator
                        getFields={fieldProps}
                        handleClose={handleClosesub}
                        datatable={data}
                    />
                </Box>
            </Modal>
            <Modal
                hideBackdrop
                open={gestorMedicinaModal}
                onClose={closeGestorMedicina}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={{ ...style, width: 600 }}>
                    <Loader2 onLoader={loader}/>
                    <h2 id="parent-modal-title" style={{width:250}}>Describa</h2>
                    <ModalFeatureJsonGestor
                        tipoDocumento={''}
                        idreferencia={0}
                        handleClose={closeGestorMedicina}
                        controllerDatajson={getConfig('medicamento')}
                        setDataJson={(jsonData) => {
                            const e = {};
                            const {medicamento, ...dat} = jsonData;
                            e.target = {
                                name: 'medicamento',
                                value: JSON.stringify(dat)
                            }
                            jsonSetter(e);
                            setJson(dat);
                        }}
                        datajson={json}
                    />
                </Box>
            </Modal>
            <Modal
                hideBackdrop
                open={gestorAlergiasModal}
                onClose={closeGestorAlergias}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={{ ...style, width: 600 }}>
                    <Loader2 onLoader={loader}/>
                    <h2 id="parent-modal-title" style={{width:250}}>Describa</h2>
                    <ModalFeatureJsonGestor
                        tipoDocumento={''}
                        idreferencia={0}
                        handleClose={closeGestorAlergias}
                        controllerDatajson={getConfig('alergias')}
                        setDataJson={(jsonData) => {
                            const e = {};
                            const {alergias, ...dat} = jsonData;
                            e.target = {
                                name: 'alergias',
                                value: JSON.stringify(dat)
                            }
                            jsonSetter(e);
                            setJson(dat);
                        }}
                        datajson={json}
                    />
                </Box>
            </Modal>
            <Modal
                hideBackdrop
                open={gestorAntecedentesModal}
                onClose={closeGestorAntecedentes}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={{ ...style, width: 600 }}>
                    <Loader2 onLoader={loader}/>
                    <h2 id="parent-modal-title" style={{width:250}}>Describa</h2>
                    <ModalFeatureJsonGestor
                        tipoDocumento={''}
                        idreferencia={0}
                        handleClose={closeGestorAntecedentes}
                        controllerDatajson={getConfig('antecedentes')}
                        setDataJson={(jsonData) => {
                            const e = {};
                            const {antecedentes, ...dat} = jsonData;
                            e.target = {
                                name: 'antecedentes',
                                value: JSON.stringify(dat)
                            }
                            jsonSetter(e);
                            setJson(dat);
                        }}
                        datajson={json}
                    />
                </Box>
            </Modal>

            <TablaGestion 
                botones ={botonesAccion}
                data={data}
                aditionalButton={printButton}
                sortModel={sortModel}
                setSortModel={setSortModel}
                formato = {RegistroClinico}
                titulo={"Registro clínico."}
                paginationModel={page}
                setPaginationModel={setPage}
            />
        </React.Fragment>
    )
}
